import { defineComponent } from 'vue';
import CategoryFourComponent from '@/components/CategoryFour/CategoryFourComponent.vue';
export default defineComponent({
    name: 'CategoryFourDuplicateDialog',
    props: {
        propSelected: Array,
        propId: String
    },
    components: { CategoryFourComponent },
    data: function () {
        return {
            show: false,
            id: this.propId
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
